import React, { Component } from 'react';
import PropTypes from 'prop-types';

import Markdown from '../../components/atoms/Markdown/Markdown';

import {
  ApplicationPaymentPageContainer,
  ApplicationPaymentPageInnerContainer,
  ApplicationPaymentPageLeftColumn,
  ApplicationPaymentPageLeftColumnInner,
  ApplicationPaymentPageRightColumn,
  LogoContainer,
  Logo,
  LogoTitle,
  LogoSubTitle,
  LogoDescription,
  ApplicaitonSubmittedText,
} from './ApplicationPaymentPage.css.js';

class ApplicationPaymentPage extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      header,
      page,
    } = this.props.content;

    return (
      <ApplicationPaymentPageContainer>
        <ApplicationPaymentPageInnerContainer>
          <ApplicationPaymentPageLeftColumn>
            <ApplicationPaymentPageLeftColumnInner>
              <LogoContainer>
                <Logo
                  src={`/images/ce-montessori/logos/ce-montessori-logo-horizontal-black-city-text.png`}
                  alt={`c'e Montessori - Logo`}
                />

                {page.logoTitle && (<LogoTitle>{page.logoTitle}</LogoTitle>)}

                {page.logoSubTitle && (<LogoSubTitle>{page.logoSubTitle}</LogoSubTitle>)}

                {page.logoDescription && (<LogoDescription>{page.logoDescription}</LogoDescription>)}
              </LogoContainer>
            </ApplicationPaymentPageLeftColumnInner>
          </ApplicationPaymentPageLeftColumn>

          <ApplicationPaymentPageRightColumn>
            <ApplicaitonSubmittedText>{page.paymentTitle}</ApplicaitonSubmittedText>

            <Markdown config={{ isSection: false }} body={page.paymentDescription} />

            <h3>{page.applicationFeeText}</h3>

            <h3>PayPal Option:</h3>
            <form action="https://www.paypal.com/cgi-bin/webscr" method="post" target="_top">
              <input name="cmd" type="hidden" value="_s-xclick" />
              <input name="hosted_button_id" type="hidden" value="2LBQUPU5VZAVY" />
              <input alt="PayPal - The safer, easier way to pay online!" name="submit" src="https://www.paypalobjects.com/en_US/i/btn/btn_paynowCC_LG.gif" type="image" />
              <img alt="" border="0" height="1" src="https://www.paypalobjects.com/en_US/i/scr/pixel.gif" width="1" />
            </form>

            {!!page.checkOptionText && (<Markdown config={{ isSection: false }} body={page.checkOptionText} />)}
          </ApplicationPaymentPageRightColumn>
        </ApplicationPaymentPageInnerContainer>
      </ApplicationPaymentPageContainer>
    );
  }
}

ApplicationPaymentPage.propTypes = {
  config: PropTypes.shape({
    hasHeader: PropTypes.bool.isRequired,
  }),
  content: PropTypes.shape({
    header: {
      config: PropTypes.shape({
        showLogo: PropTypes.bool,
      }),
      content: PropTypes.shape({
        navigationItems: PropTypes.shape({
          label: PropTypes.string.isRequired,
          link: PropTypes.string.isRequired,
        }).isRequired,
      }),
    },
    page: PropTypes.shape({
      title: PropTypes.string.isRequired,
      subtitle: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      featuredImage: PropTypes.string,
    }).isRequired,
  }),
};

ApplicationPaymentPage.defaultProps = {
  config: {
    hasHeader: true,
  },
};

export default ApplicationPaymentPage;